import { Link } from "react-router-dom";

/**
 * "Cards under this name": cards whose player is NOT public (unverified, or unknown to
 * the tracker). Never a player card — a followed rookie and an orphan card are not the
 * same thing. Grouped by set: six Flagship lines in a row are unreadable.
 */
export default function CardHits({ hits, t }) {
  if (!hits?.length) return null;
  const groups = [];
  hits.forEach((c) => {
    const key = [c.set_name, c.season].filter(Boolean).join(" · ");
    const last = groups[groups.length - 1];
    if (last && last.key === key) last.cards.push(c);
    else groups.push({ key, cards: [c] });
  });

  return (
    <section className="wl-panel mt-5 p-3" data-testid="watchlist-card-hits">
      <h2 className="font-display text-base font-bold uppercase tracking-tight text-[var(--wl-text)]" data-testid="card-hits-title">
        {t("cards.hits_title")}
      </h2>
      <p className="wl-mono mt-1 text-[10px] uppercase tracking-[.04em] text-[var(--wl-muted)]" data-testid="card-hits-sub">
        {t("cards.hits_sub")}
      </p>
      <div className="mt-3 space-y-3">
        {groups.map((g) => (
          <div key={g.key} data-testid={`card-hits-group-${g.key}`}>
            <div className="wl-mono border-b border-[var(--wl-line)] pb-1 text-[9.5px] uppercase tracking-[.06em] text-[var(--wl-muted)]">
              {g.key}
            </div>
            <ul className="wl-mono text-[10.5px]">
              {g.cards.map((c) => (
                <li key={c.id} className="border-b border-[var(--wl-line)]/50 py-1">
                  <Link to={`/cards/${c.id}`} className="flex flex-wrap items-baseline gap-x-2 text-[var(--wl-text)] hover:text-[var(--wl-accent)]" data-testid={`card-hit-${c.id}`}>
                    <span className="min-w-[46px] text-[var(--wl-muted)]">{c.card_number || "—"}</span>
                    <span className="font-bold">{c.player_name_raw}</span>
                    <span className="text-[var(--wl-muted)]">{c.subset && c.subset !== "Base" ? c.subset : c.parallel}</span>
                    {c.is_rookie && <span className="text-[var(--wl-accent)]">RC</span>}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
